<template>
  <div :class="buttonClasses">
    <GhostButton
      :text="text"
      :icon="icon"
      :size="size"
      :disabled="disabled"
      :active="active"
    >
      <template v-if="$slots.default" #default>
        <slot />
      </template>
    </GhostButton>
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "../Dropdown.module.scss";
import GhostButton from "@/elements/UI/button/ButtonStyle/Default/ghost/GhostButton.vue";

export default defineComponent({
  name: "DropdownButton",
  components: {GhostButton},
  props: {
    text: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    size: {
      type: String as PropType<Size>,
      default: "S"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    // технические свойства
    index: {
      type: Number,
      default: 0
    },
    maxSize: {
      type: Number,
      default: 0
    }
  },
  computed: {
    positionClass(): string {
      if (this.maxSize <= 1) {
        return style.single;
      }

      if (this.index === 0) {
        return style.first;
      }

      if (this.index === this.maxSize - 1) {
        return style.last;
      }

      return style.middle;
    },

    buttonClasses(): string[] {
      return [style.dropdown, style[`size${this.size}`], this.positionClass];
    }
  }
});
</script>
